import React, { useState } from "react";

import { Icon } from 'react-icons-kit';
import { check } from 'react-icons-kit/feather/check'

import styles from "../../../pages/DashBoard/ExternalDash/Issuer/ChangeRequest.module.css"
import TableStyles from "../../../pages/DashBoard/AllUsers.module.css"
import { setDate } from "../../../Utils/helper";

export default function ViewRequestedChanges({ data }) {

    const [loadShimmer, setLoadshimmer] = useState(0)

    if (loadShimmer == 3) {
        return (
            <section className={styles.searchBox}>
                <h2 className='topTitleBarText'>
                    <div className="shimmer" style={{ width: '5rem', height: '2rem' }} />
                </h2>
                <div className='shimmer' style={{ width: "100%", height: "5rem" }}>
                </div>
            </section>)
    }
    let status = data.status
    return (
        <div>

            <table>
                <tbody>
                    <tr className={TableStyles.chevronSortTableCell5}>
                        <th className={TableStyles.tablescell + " " + styles.th}>
                            Field Name
                        </th>
                        <th className={TableStyles.tablescell + " " + styles.th}>
                            Original Value
                        </th>
                        <th className={TableStyles.tablescell + " " + styles.th}>
                            Requested Value
                        </th>
                        <th className={TableStyles.tablescell + " " + styles.th}>
                            Supporting Document
                        </th>
                    </tr>
                    {data?.discrepancy_log_data?.details.map((i) => (
                        <tr className={TableStyles.chevronSortTableCell} key={i.doc_field_id}>
                            <td className={styles.td + " " + TableStyles.tablescell}>
                                {i.doc_field_name}
                            </td>
                            <td className={styles.td + " " + TableStyles.tablescell}>
                                {i.old_value}
                            </td>
                            <td className={styles.td + " " + TableStyles.tablescell}>
                                {i.estimated_correct_value}
                            </td>
                            <td className={styles.td + " " + TableStyles.tablescell}>
                                {i.supporting_document_name || 'No Document Added'}
                            </td>
                        </tr>
                    )
                    )}
                </tbody>
            </table>
            <div className={[styles.commentContainer, styles[status]].join(" ")}>
                <div className={styles.commentHeading}>
                    <img src={status == 'Accepted' ? '/checkcircle.svg' : '/cancel.svg'} className={styles.commentHeadingIcon}></img>
                    <h4>Request is {status} on {setDate(data.updated_at)}</h4>
                </div>
                {data.comment || 'No Comment was added'}
            </div>
            <div>
                {
                    status == 'Accepted' &&
                    <div className={styles.approvedlistContainer}>
                        {
                            data.discrepancy_log_data.details.map(e => {
                                let status = e.status == 'Approved'
                                return (
                                    <div className={styles.approvedlist}>
                                        <div><b>{e.doc_field_name}</b></div>
                                        <div className={styles.status}
                                            style={status ? { background: '#DEF7EC', color: '#03543F' } : null}
                                        >{status ? 'approved' : 'rejected'}</div>
                                    </div>
                                )
                            }
                            )
                        }
                    </div>
                }

            </div>
        </div>

    )

}